import en from "./en";
import fr from "./fr";

// All available translations keyed by locale code
export const translations = { en, fr };

// Supported locales
export const LOCALES = ["en", "fr"];

// Default locale
export const DEFAULT_LOCALE = "en";
